<div class="choice-plan animatedParent">
  <div class="container">
    <h2 class="text-center">Домашний интернет c ТВ</h2>
    <p class="text-center">Для своих клиентов мы предлагаем гибкую сетку тарифов</p>
    <!--<li>
      <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
      <h5>Octopus 200</h5>
      <p>Скорость: до 200 мб/c</p>
      <br>
      <span><b>Стоимость</b></span>
      <div class="price">690₽<span>/месяц</span></div>
      <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
    </li>
    <li>
      <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
      <h5>Octopus 300</h5>
      <p>Скорость: до 300 мб/c</p>
      <br>
      <span><b>Стоимость</b></span>
      <div class="price">990₽<span>/месяц</span></div>
      <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
    </li>-->
    <!--===================== Nav Tabs ========================-->
    <ul class="nav nav-tabs" role="tablist">
      <li class="active"><a href="#monthly" aria-controls="monthly" role="tab" data-toggle="tab">Условия для всех клиентов</a></li>
      <li><a href="#yearly" aria-controls="yearly" role="tab" data-toggle="tab">Специальные условия</a></li>
    </ul>
    <!--===================== End of Nav Tabs ========================-->
    <div class="tab-content">
      <!--===================== Tab Monthly ========================-->
      <div role="tabpanel" class="tab-pane active" id="monthly">
        <ul class="pricing-list">
          <li>
            <div class="images"><img src="assets/images/basic-plan.svg" alt="hosting"></div>
            <h5>Octopus "Простой"</h5>
            <p>Скорость: до 100 мб/c</p>
            <br>
            <span><b>Стоимость</b></span>
            <div class="price">440₽<span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn text-white">Начать</a>
            <a href="javascript:void(0)" (click)="openPopupTV('prosto')" class="custom-btn blue btn-link btn btn-outline-info">Список каналов</a>
          </li>
          <!-- <li class="animated bounceInLeft delay-250">
            <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
            <h5>Стартовый +</h5>
            <p>Подойдет для опытных пользователей</p>
              <br>
            <span><b>Стоимость</b></span>
            <div class="price">200₽<span>/месяц</span></div>
            <a href="service-page.html" class="custom-btn">Начать</a>
          </li> -->
          <li>
            <div class="images"><img src="assets/images/star-plan.png" alt="hosting"></div>
            <h5>Octopus "Лайт"</h5>
            <p>Скорость: до 100 мб/c</p>
            <br>
            <span><b>Стоимость</b></span>
            <div class="price">505₽<span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
            <a href="javascript:void(0)" (click)="openPopupTV('light')" class="custom-btn btn btn-outline-info">Список каналов</a>
          </li>
          <li>
            <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
            <h5>Octopus "Базовый"</h5>
            <p>Скорость: до 100 мб/c</p>
            <br>
            <span><b>Стоимость</b></span>
            <div class="price">680₽<span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
            <a href="javascript:void(0)" (click)="openPopupTV('base')" class="custom-btn btn btn-outline-info">Список каналов</a>
          </li>
        </ul>
      </div>
      <!--===================== End of Tab Monthly ========================-->
      <!--===================== Yearly ========================-->
      <div role="tabpanel" class="tab-pane" id="yearly">
        <ul class="pricing-list">
          <li>
            <div class="images"><img src="assets/images/basic-plan.svg" alt="hosting"></div>
            <h5>«Выгодный переход и ТВ «Простой»</h5>
            <p>Скорость: до 50 мб/c</p>
            <br>
            <span><b>Стоимость</b></span>
            <div class="price">170₽<sup>*</sup><span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn text-white">Начать</a>
            <a href="javascript:void(0)" (click)="openPopupTV('prosto')" class="custom-btn btn btn-outline-info">Список каналов</a>
            <app-special-price></app-special-price>
          </li>
          <!-- <li class="animated bounceInLeft delay-250">
            <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
            <h5>Стартовый +</h5>
            <p>Подойдет для опытных пользователей</p>
              <br>
            <span><b>Стоимость</b></span>
            <div class="price">200₽<span>/месяц</span></div>
            <a href="service-page.html" class="custom-btn">Начать</a>
          </li> -->
          <li>
            <div class="images"><img src="assets/images/star-plan.png" alt="hosting"></div>
            <h5>«Выгодный переход и ТВ «Лайт»</h5>
            <p>Скорость: до 75 мб/c</p>
            <br>
            <span><b>Стоимость</b></span>
            <div class="price">290₽<sup>*</sup><span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
            <a href="javascript:void(0)" (click)="openPopupTV('light')" class="custom-btn btn btn-outline-info">Список каналов</a>
            <app-special-price></app-special-price>
          </li>
          <li>
            <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
            <h5>«Выгодный переход и ТВ «Базовый»</h5>
            <p>Скорость: до 100 мб/c</p>
            <br>
            <span><b>Стоимость</b></span>
            <div class="price">430₽<sup>*</sup><span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
            <a href="javascript:void(0)" (click)="openPopupTV('base')" class="custom-btn btn btn-outline-info">Список каналов</a>
            <app-special-price></app-special-price>
          </li>
        </ul>
      </div>
      <!--===================== End of Tab Yearly ========================-->
    </div><!--tab-content-->
  </div><!--container-->
  <!--===================== Info Plan ========================-->
  <!--<div class="info-plan">
    <div class="container">
      <div class="row">
        <div class="col-md-6 animated bounceInLeft">
          <img src="assets/images/improving.png" alt="improving">
          <h5>Always Improving</h5>
          <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
        </div>
        <div class="col-md-6 animated bounceInRight">
          <img src="assets/images/secured.png" alt="improving">
          <h5>100% Secured</h5>
          <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
        </div>
      </div>
    </div>
  </div>-->
  <!--===================== End of Info Plan ========================-->
</div>


<div class="animatedParent">
  <div class="container">
  </div><!--container-->
  <!--===================== Info Plan ========================-->
  <div class="info-plan">
    <div class="container">
      <div class="row">
        <div class="col-md-12 animated bounceInLeft">
          <div class="text-center">
            <img src="assets/images/powerfull.svg" alt="improving">
            <h5>Дополнительная информация</h5>
          </div>




          <p class="pb-2 mb-2">ООО "ТЕЛЕКОМ - ОРЕЛ" в рамках предоставления IP телевидения (цифрового телевидения) действует в качестве Агента.Услуга предоставляется ООО "Медиаоператор", торговая марка Moovi.
            <a class="btn-link" target="_blank" href="/assets/file/dov.pdf">Доверенность</a></p>
          <div>
            <h6> Договор на оказание услуг связи для целей телевизионного вещания: <a class="d-inline-block" target="_blank" href="/assets/file/obr.pdf"> скачать образец абонентского договора</a></h6>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--===================== End of Info Plan ========================-->
</div>

